const AddressRestrictions = ({
  hasRestrictionErrorMessage = false,
  errorMessage = '',
  paidListingExists = false,
} = {}) => ({
  hasRestrictionErrorMessage: Boolean(hasRestrictionErrorMessage),
  errorMessage,
  paidListingExists: Boolean(paidListingExists),
});

export default AddressRestrictions;

export type AddressRestrictionsProps = ReturnType<typeof AddressRestrictions>;
